var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      ref: "step",
      staticClass: "step",
      attrs: { id: `somnambulist-step-${_vm.stepNumber}` },
    },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("step-header", {
                    attrs: {
                      "lang-string-id": _vm.headerLangStringId,
                      number: _vm.stepNumber,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(_vm.stepComponent, {
            tag: "component",
            on: {
              modalToggled: function ($event) {
                return _vm.$emit("modalToggled")
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }